import { StateSliceName, StateSliceDefaults } from '@oneapp/main/core/store.models';

export enum BundleIndividualGamesFormControl {
    STRING_FILTER = 'stringFilter'
}

export interface BundleIndividualGamesFormValues {
    [BundleIndividualGamesFormControl.STRING_FILTER]: string | undefined;
}

export const bundleIndividualGamesFormValuesDefault: BundleIndividualGamesFormValues = {
    [BundleIndividualGamesFormControl.STRING_FILTER]: undefined
};

export interface BundleIndividualGamesStateModel {
    formValues: BundleIndividualGamesFormValues;
}

export const bundleIndividualGameStateDefaults: StateSliceDefaults<BundleIndividualGamesStateModel> = Object.freeze({
    sliceName: StateSliceName.BUNDLE_INDIVIDUAL_GAMES,
    defaults: {
        formValues: bundleIndividualGamesFormValuesDefault
    }
});

export enum BundleIndividualGamesDataCySelector {
    FILTER_INPUT = 'individual-bundle-search-input',
    OA_GAME_DELETION_BUTTON = 'oa-game-delete-button',
    OA_ERROR_NOTIFICATION = 'oa-error-notification',
}
